module.exports = __webpack_public_path__ + "static/final.13ba4c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/dialogs/final.png
// module id = 196
// module chunks = 180372703912199 191454017231275